import Vue from "vue";
import {Concert, Spectacle, Film, OtherEvent} from '@/api/';
import availableWidgetsForms from '@/components/widgets/availableWidgetsForms'

Vue.mixin({
    methods: {
        addLanguageSuffix (field) {
            return `${field}_${this.$store.state.currentFormLanguage}`
        },
        getRouteName (route) {
            if (route.meta && route.meta.label) {
                return route.meta.label
            }
            return route.name
        },
        changeOrder (arr, index, direction) {
            const placeAfterSwap = index + direction
            if (placeAfterSwap < 0 || placeAfterSwap >= arr.length) {
                return
            }
            const tmp = arr[index]
            this.$set(arr, index, arr[placeAfterSwap])
            this.$set(arr, placeAfterSwap, tmp)
        },
        checkForErrors (errorsList, nestedFieldsArray) {
            /**
             *  Check if in nested array of errors is error for proper specific field
             *  errorsList - array of formset errors, e.g. [{}. {name: 'Incorrect name'}]
             *  nestedFieldsArray - path to specific error object, e.g. [1]
             */
            let errors = errorsList
            if (!Array.isArray(errors)) {
                return false
            }

            for (let i = 0; i < nestedFieldsArray.length; i++) {
                if (errors === undefined) {
                    return false
                }
                errors = errors[nestedFieldsArray[i]]
            }
            if (errors === undefined) return false
            return Object.keys(errors).length > 0
        },
        getWidgetComponent (type) {
            return availableWidgetsForms[type]
        },
        successHandler (response) {
            if (this.loading !== undefined) {
                this.loading = false
            }

            const message = response.status === 201 ? 'Element został dodany' : 'Zmiany zostały zapisane'

            this.$message({
                message: message,
                type: 'success'
            });

            if (this.redirectRoute) {
                this.$router.push(this.redirectRoute)
            }
        },
        errorHandler (error) {
            if (this.loading !== undefined) {
                this.loading = false
            }

            if (error.response) {
                // The request was made and the server responded with a status code
                // that falls out of the range of 2xx
                const errors = error.response.data


                let message = 'Wystąpił problem podczas przetwarzania formularza.'

                if (error.response.data.non_field_errors !== undefined) {
                    message += '<br>' + error.response.data.non_field_errors.join(', ')
                }

                if (error.response.status === 413) {
                    message += '<br> Przesłane dane (np. pliki) są zbyt duże.'
                }

                this.$message({
                    message: message,
                    dangerouslyUseHTMLString: true,
                    type: 'error'
                })

                let languageErrors = {}

                // make sure errors are strings
                const parseErrorsDict = errorsObj => {
                    Object.keys(errorsObj).forEach(key => {
                        if (key.endsWith('_en') || key.endsWith('_pl')) {
                            let parts = key.split('_')
                            const lang = parts[parts.length - 1]
                            languageErrors[lang] = true
                        }
                        let values = errorsObj[key];
                        if (Array.isArray(values)) {
                            if (typeof values[0] === 'string') {
                                errorsObj[key] = values.join(', ')
                            } else if (typeof values[0] === 'object') {
                                for (let i = 0; i < values.length; i++) {
                                    errorsObj[key][i] = parseErrorsDict(values[i])
                                }
                            }
                        }
                    })
                    return errorsObj
                }

                this.errors = parseErrorsDict(errors)

                // check if error was caused by another language than chosen
                languageErrors = Object.keys(languageErrors)
                const currentFormLanguage = this.$store.state.currentFormLanguage

                if (languageErrors.length > 0 && !languageErrors.includes(currentFormLanguage)) {
                    this.$store.commit('setCurrentFormLanguage', languageErrors[0])
                }
            } else if (error.request) {
                // The request was made but no response was received
                // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
                // http.ClientRequest in node.js
                console.log(error.request);
            } else {
                // Something happened in setting up the request that triggered an Error
                let message = 'Wystąpił problem podczas przetwarzania formularza.<br> Sprawdź czy przesłane dane nie są zbyt duże.'

                console.log('Error', error.message);
                this.$message({
                    message: message,
                    dangerouslyUseHTMLString: true,
                    type: 'error'
                })
            }
        },
        removeItemFromFormset (field, item) {
            const index = field.indexOf(item)
            if (index > -1) {
                field.splice(index, 1)
            }
        },
        duplicateAnotherField (value, target) {
            if (!this.form[target]) {
                this.form[target] = value
            }
        },
    },
    computed: {
        eventDetails () {
            // get event details based on meta eventType
            const type = this.$route.meta.eventType
            const events = {
                'theater': {
                    routes: {add: 'Add Spectacle', edit: 'Edit Spectacle'},
                    labels: {name: 'Nazwa sztuki', additional_name: 'Nazwa teatru'},
                    service: Spectacle
                },
                'music': {
                    routes: {add: 'Add Concert', edit: 'Edit Concert'},
                    labels: {name: 'Nazwa wykonawcy'},
                    service: Concert
                },
                'others': {
                    routes: {add: 'Add OtherEvent', edit: 'Edit OtherEvent'},
                    labels: {name: 'Nazwa wydarzenia'},
                    service: OtherEvent
                },
                'cinema': {
                    routes: {add: 'Add Film', edit: 'Edit Film'},
                    labels: {name: 'Nazwa filmu', additional_name: 'Reżyser'},
                    service: Film
                }
            }
            return events[type]
        }
    }
})



// WEBPACK FOOTER //
// ./src/mixins/index.js